import React from "react";
import { deleteCelebrityDayByDate } from "../../../services/celebrity-days.service.ts";
import { notification } from "../../../utils/Notifications.tsx";

interface DeleteCelebrityDayProps {
  closeFn: () => void;
  refreshFn: () => void;
  celebrityDay: {
    id: number;
    date: string;
    title: string;
    bonusType: string;
  };
  setLoading: (loading: boolean) => void;
}

const DeleteCelebrityDay = ({ closeFn, refreshFn, celebrityDay, setLoading }: DeleteCelebrityDayProps) => {
  const removeRecord = async () => {
    try {
      setLoading(true);
      await deleteCelebrityDayByDate(celebrityDay.date);
      refreshFn();
      closeFn();
      notification("Eliminado", "Día festivo eliminado correctamente", "success");
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Error al eliminar el día festivo";
      notification("Error", errorMessage, "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar el día festivo <strong>"{celebrityDay.title}"</strong> del {celebrityDay.date}?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => removeRecord()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default DeleteCelebrityDay;
